import * as React from "react";
const SvgFiRrMoneyTransferCoinArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-money-transfer-coin-arrow_svg__a)">
      <path
        fill="#062147"
        d="M1 13a1 1 0 0 1-1-1C0 5.383 5.383 0 12 0c3.449 0 6.733 1.518 9 4.087V1a1 1 0 1 1 2 0v4c0 1.103-.897 2-2 2h-4a1 1 0 1 1 0-2h2.122A10.04 10.04 0 0 0 12 2C6.486 2 2 6.486 2 12a1 1 0 0 1-1 1m22-2a1 1 0 0 0-1 1c0 5.514-4.486 10-10 10-2.688 0-5.255-1.107-7.123-3H7a1 1 0 1 0 0-2H3c-1.103 0-2 .897-2 2v4a1 1 0 1 0 2 0v-3.087C5.267 22.482 8.551 24 12 24c6.617 0 12-5.383 12-12a1 1 0 0 0-1-1m-12.142 8.919c.374.054.759.081 1.142.081 4.411 0 8-3.589 8-8 0-.78-.111-1.55-.332-2.287a1 1 0 0 0-1.916.574 6.006 6.006 0 0 1-6.61 7.652 1 1 0 1 0-.283 1.979zM12 6q.431 0 .859.061a1.002 1.002 0 0 0 .281-1.981 8 8 0 0 0-1.141-.081c-4.411 0-8 3.589-8 8 0 .777.111 1.546.331 2.286a1.002 1.002 0 0 0 1.918-.571 6.006 6.006 0 0 1 5.751-7.715zm1.126 8.2h-2.204a.7.7 0 0 1-.564-.287c-.142-.193-.433-.213-.552-.213a.8.8 0 0 0-.732.477.76.76 0 0 0 .122.84 2.3 2.3 0 0 0 1.727.783h.278v.7a.8.8 0 0 0 1.6 0v-.7h.326c.647 0 1.257-.287 1.673-.787a2.19 2.19 0 0 0 .463-1.803c-.16-.853-.889-1.551-1.812-1.735l-2.688-.539a.574.574 0 0 1 .112-1.136h2.204c.223 0 .434.107.564.287.142.193.433.213.552.213a.8.8 0 0 0 .732-.476.765.765 0 0 0-.121-.841 2.3 2.3 0 0 0-1.728-.782h-.277v-.7a.8.8 0 0 0-1.6 0v.7h-.327a2.174 2.174 0 0 0-2.135 2.59c.159.853.887 1.55 1.812 1.735l2.688.538a.575.575 0 0 1-.112 1.137z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-money-transfer-coin-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMoneyTransferCoinArrow;
